import {useDiffStore} from './DiffStore'

// State selectors
export const useIsDraggingAddCommentButton = () =>
  useDiffStore(s => s.draggingAddCommentButton.isDraggingAddCommentButton)
export const useFirstLineNumberSelection = () => useDiffStore(s => s.lineSelection.firstLineNumberSelection)

// Actions selectors
export const useDraggingAddCommentButtonActions = () => useDiffStore(s => s.draggingAddCommentButtonActions)
export const useLineSelectionActions = () => useDiffStore(s => s.lineSelectionActions)
export const useInjectedContextLinesActions = () => useDiffStore(s => s.injectedContextLinesActions)
